import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#text-description" }),
  /*#__PURE__*/_createTextVNode(" Text description ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_switch, {
        style: {"margin-bottom":"5px"},
        modelValue: _ctx.value1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
        "active-text": "Pay by month",
        "inactive-text": "Pay by year"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_switch, {
        style: {"display":"block"},
        modelValue: _ctx.value2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
        "active-color": "#13ce66",
        "inactive-color": "#ff4949",
        "active-text": "Pay by month",
        "inactive-text": "Pay by year"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}